import './hierarchy_pie_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.HierarchyNavigationChartView extends Monitoring.Views.Charts.HierarchyPieChartView
  template_path: JST['backbone/templates/monitoring/charts/tree_path']

  events: () ->
    _.extend({}, Monitoring.Views.Charts.HierarchyPieChartView.prototype.events,
      'click .subpath': 'onSubpath'
      'mouseover .subpath': 'onMouseOver'
      'mouseout .subpath': 'onMouseOut'
      'click #close_chart': 'destroy'
      'click .taxonomyChoise': 'changeTaxonomy',
      'click #change_hierarchy': 'onClickChangeHierarchy'
    )

  initialize: (@options = {}) =>
    @title = I18n.t('monitoring.dashboard.charts.h_navigation')
    @title_en = I18n.t('monitoring.dashboard.charts.h_navigation', {'locale': 'en'})
    @path = @options.settings.path || []
    @inClickWindowTime = false
    super
    @taxonomiesRepository = new Monitoring.Models.TaxonomiesRepository
    @_settings.currentTaxonomyCode = @_settings.currentTaxonomyCode || 'Default'

  afterAppend: ->
    if @hierarchyNavigator
      @firstRender = false
      @data = @hierarchyNavigator.extractData()
      @_settings.path = @path
      if @onMaximaze
        @onMaximaze = !@onMaximaze
      else
        @trigger('chartsChange')
      super
    else
      @taxonomiesRepository.loadAlternativeTaxonomies(() =>
        @$el.find('#close_chart').before(@hierarchySelectingTemplate(
          includeAlternativeTaxonomies: Keepcon.currentAccount.includeAlternativeTaxonomies,
          taxonomiesRepository: @taxonomiesRepository
        ))
        query = @searchQuery.deepCopy()
        query.set('taxonomy_code', @_settings.currentTaxonomyCode)        
        @ajaxCall(@url, query.toJSON(), (response) =>
          @hierarchyNavigator = new Monitoring.Views.Charts.HierarchyNavigator(@path, response, {})
          @data = @hierarchyNavigator.extractData()
          @firstRender = true
          super
        )
      )
    $(this.el).find("#path").html(@template_path(tree_path: @_path()))
    return this

  _path: ->
    if @hierarchyNavigator then @hierarchyNavigator.path else @path
      
  _dataIsEmpty: ->
    if @hierarchyNavigator then @hierarchyNavigator.dataIsEmpty() else false

  _getOptions: ->
    defaultOptions = new Customer.Reports.PieOptions(
      container: @$el.find('.chart')[0]
      onToggleMaximize: => @toggleMaximize()
      isMaximized: @_settings.maximized
    ).get()

    customOptions = {
      chart:
        type: "pie"
        backgroundColor: '#FFFFFF'
        marginBottom: 35
        marginTop: 25
      title:
        text: null
      legend:
        labelFormatter: -> @name
      plotOptions:
        pie:
          borderColor: "rgba(0,0,0,0)"
          point:
            events:
              legendItemClick: @eventDispatch
      exporting:
        chartOptions:
            title:
              text: ["root"].concat(@path).join(" | ")
        filename: ["root"].concat(@path).join(" | ")
    }                
    options = $.extend(true, defaultOptions, customOptions)
    options.series = @_series()
    options.tooltip.formatter = @_tooltipFormatter

    return options

  _tooltipFormatter: () ->
    if @key
      name = @point.original_name || @point.name
      "<b>#{name}</b><br/>Cantidad: #{@point.y} (#{Math.round(@percentage * 10) / 10}%)"
    else
      false

  _series: ->
    serie_data = []
    total=0
    for tag in @data
      total = total + tag.y
    for tag in @data
      percentage = ((tag.y/total)*100).toFixed(2)
      serie_element = $.extend({}, tag);
      serie_element.original_name = serie_element.name
      serie_element.name = serie_element.name + " (#{percentage}%)"
      serie_data.push serie_element
      serie_element.visible = @getVisibilityFor(serie_element.name)
    [
      {
        data: serie_data
        slicedOffset: 0,
        point:
          events:
            click: @dispatchEvent
            legendItemClick: @legendItemClickEvent
      }
    ]

  deepInto: (event) =>
    target_name = event.point.original_name.trim()
    if @hierarchyNavigator.deepInto(target_name)
      @afterAppend()

  onSubpath: (event) =>
    text = @htmlDecode(event.target.innerHTML.trim())
    if @hierarchyNavigator.onSubpath(text)
      @afterAppend()

  dispatchEvent: (event)=> 
    if @inClickWindowTime
      clearTimeout(@delayed_timeout) if @delayed_timeout
      @deepInto(event)
      @inClickWindowTime = false
    else
      @delayed_timeout = setTimeout((=>@_pieClick event), 400)
      @inClickWindowTime = true

  _pieClick: =>
    @inClickWindowTime = false
    super

  onMouseOver: (event) =>
    $(event.target).addClass("link-path")

  onMouseOut: (event) =>
    $(event.target).removeClass("link-path")

  toggleMaximize: =>
    @onMaximaze = true
    super

  htmlDecode: (input) ->
    e = document.createElement('div')
    e.innerHTML = input
    e.childNodes[0].nodeValue

  onClickChangeHierarchy: (evt) ->
    @$el.find('#change_hierarchy_menu').toggleClass('taxonomy_dropdown_show')

  changeTaxonomy: (evt) ->
    chosenTaxonomyName = $(evt.target).text()
    @$el.find('#change_hierarchy_menu').toggleClass('taxonomy_dropdown_show')
    taxonomy = @taxonomiesRepository.taxonomyWithName(chosenTaxonomyName)
    @_settings.currentTaxonomyCode = taxonomy.get('code')
    query = @searchQuery.deepCopy()
    query.set('taxonomy_code', @_settings.currentTaxonomyCode)
    @ajaxCall(@url, query.toJSON(), (response) =>
      @hierarchyNavigator = new Monitoring.Views.Charts.HierarchyNavigator(@path, response, {})
      @data = @hierarchyNavigator.extractData()
      unless @hierarchyNavigator.existsPathInTree()
        @path = @options.settings.path || []
        @hierarchyNavigator.onSubpath('')
      @firstRender = false
      @afterAppend()
    )
